export default __webpack_public_path__ + "static/media/snake.3a4608af.mp3";